// IMPORT into theme.liquid 
// <script src="{{ 'gdc-component-logo-list-drawer.js' | asset_url }}" defer="defer"></script>

const _dS = {
  aClass: `.gdc-logo-list-drawer__mobile-arrow`,
  pClass: `.gdc-logo-list-drawer__logo-pointer`,
  dClass: `.gdc-logo-list-drawer__info`,
  aBlock: (blockId) => `.gdc-logo-list-drawer__mobile-arrow[data-block="${blockId}"]`,
  pBlock: (blockId) => `.gdc-logo-list-drawer__logo-pointer[data-block="${blockId}"]`,
  dBlock: (blockId) => `.gdc-logo-list-drawer__info[data-block="${blockId}"]`,
  allSectionPointer: (elem) => elem.parentElement.querySelectorAll(_dS.pClass)
}

const getPointerById = (id) => document.querySelector(_dS.pBlock(id))
const getDrawerById = (id) =>  document.querySelector(_dS.dBlock(id)) 
const getArrowById = (id) =>  document.querySelector(_dS.aBlock(id)) 

function closeActiveDrawer(elem)  {
  const blockId = elem.dataset.block

  getDrawerById(blockId).classList.remove("reveal-drawer")
  getPointerById(blockId).classList.remove("reveal-pointer")
  getArrowById(blockId).classList.remove("activate-arrow")
}

function activatePointer(elem) {
  const pointers = elem.parentElement.querySelectorAll(_dS.pClass)
  const selectedPointerId = elem.querySelector(_dS.pClass).dataset.block

  pointers.forEach(pointer => {
    let pointerId = pointer.dataset.block

    pointer.classList.remove("reveal-first-pointer-desktop") 
    pointerId === selectedPointerId
      ? pointer.classList.toggle("reveal-pointer")
      : pointer.classList.remove("reveal-pointer") 
  });
}

function handleMobileArrow(elem) {
  const arrows = elem.parentElement.querySelectorAll(_dS.aClass)
  const activeArrowId = elem.querySelector(_dS.aClass).dataset.block;
  
  arrows.forEach(arrow => {
    let arrowId = arrow.dataset.block

    arrowId === activeArrowId
      ? arrow.classList.toggle('activate-arrow')
      : arrow.classList.remove('activate-arrow')   
  })

}

function activateSelectedLogoDrawer(elem) {
  const blockId = elem.dataset.block
  const drawers = elem.parentElement.querySelectorAll(_dS.dClass)
  const selectedDrawer = elem.parentElement.querySelector(_dS.dBlock(blockId))

  drawers.forEach(drawer => {
    drawer.classList.remove("reveal-first-drawer-desktop") 
    drawer === selectedDrawer
      ? drawer.classList.toggle("reveal-drawer")  
      : drawer.classList.remove("reveal-drawer")
  });
}


function toggleLogoDrawer(elem) {
  if (screen.width < 400) {
    handleMobileArrow(elem)
  }
  activatePointer(elem)
  activateSelectedLogoDrawer(elem) 
}